import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Trésorerie SCI et immobilier : gérer les loyers et les charges | Trezoone',
    description: 'Gérez la trésorerie de votre SCI ou activité immobilière : suivi des loyers, charges, remboursements d\'emprunt et prévision des flux.',
    canonical: '/tresorerie-sci-immobilier',
    keywords: 'trésorerie SCI, trésorerie immobilier, gestion trésorerie bailleur, flux trésorerie immobilier',
  },
  hero: {
    tag: 'Trésorerie SCI et immobilier',
    title: 'Loyers, charges, travaux, emprunts : la trésorerie immobilière mérite un outil dédié.',
    subtitle: 'Une SCI ou un patrimoine immobilier locatif a des flux de trésorerie spécifiques. Voici comment les suivre efficacement.',
    ctaLabel: 'Organiser ma trésorerie immobilière',
  },
  pilierLink: { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Les flux de trésorerie spécifiques à l\'immobilier locatif',
      content: 'Une SCI ou un investisseur immobilier gère des flux réguliers et des flux exceptionnels :',
      items: [
        'Flux réguliers : loyers mensuels (par locataire), charges de copropriété, remboursements d\'emprunt',
        'Flux semestriels/annuels : taxe foncière, assurances propriétaire non-occupant',
        'Flux exceptionnels : travaux, vacances locatives, impayés, sinistres',
        'Enjeu : avoir toujours le cash pour les remboursements d\'emprunt même en cas de vacance',
      ],
    },
    {
      type: 'example',
      title: 'Exemple : SCI avec 3 lots',
      content: 'SCI avec 3 appartements. Loyers totaux : 2 800 €/mois. Emprunt : 1 900 €/mois.',
      items: [
        'Taux de charge : 68 % des loyers pour les remboursements → peu de marge',
        'Risque : vacance locative d\'1 appartement → -900 €/mois → tension sur l\'emprunt',
        'Avec Trezoone : modélisation des flux par lot → simulation de l\'impact d\'une vacance',
        'Action préventive : réserve de 2 mois de loyers constituée avant chaque bail',
      ],
    },
    {
      type: 'midcta',
      title: 'Une vacance locative peut mettre votre emprunt en danger — modélisez l\'impact avant qu\'il arrive',
      content: 'Trezoone suit chaque loyer par locataire, simule les impacts de vacance et vous alerte si votre réserve est insuffisante.',
    },
    {
      type: 'solution',
      title: 'Trezoone pour la gestion de trésorerie SCI',
      content: 'Suivez vos flux immobiliers avec la même rigueur qu\'un professionnel.',
      items: [
        'Suivi des encaissements par locataire et par lot',
        'Alertes en cas de loyer non reçu à la date prévue',
        'Plan de trésorerie intégrant les remboursements d\'emprunt',
        'Simulation de l\'impact d\'une vacance locative',
        'Suivi des travaux et dépenses exceptionnelles',
      ],
    },
    {
      type: 'cluster',
      title: 'Outils pour les investisseurs et propriétaires',
      links: [
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
        { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
        { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
        { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Pilotez la trésorerie de votre SCI avec rigueur',
      content: 'Trezoone adapté à l\'immobilier locatif. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
    { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
    { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
    { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieImmobilierPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
